import type { ComponentProps } from 'react';

type Props = {
  size?: number;
} & ComponentProps<'svg'>;

export const OriginalCategoryPermissionIcon = ({
  size = 16,
  ...props
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_category_permission"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_category_permission)">
        <path
          d="M10.9354 12.8346C10.9351 12.5394 10.6954 12.3005 10.4002 12.3004C10.1049 12.3004 9.86526 12.5393 9.86504 12.8346C9.86504 13.1301 10.1047 13.3697 10.4002 13.3697C10.6956 13.3696 10.9354 13.13 10.9354 12.8346ZM12.2654 12.8346C12.2654 13.8645 11.4301 14.6997 10.4002 14.6998C9.37018 14.6998 8.53496 13.8646 8.53496 12.8346C8.53518 11.8048 9.37032 10.9703 10.4002 10.9703C10.6711 10.9704 10.9277 11.0295 11.16 11.1334L13.5301 8.76428C13.7898 8.505 14.2109 8.50481 14.4705 8.76428C14.7302 9.02398 14.7302 9.44599 14.4705 9.70569L14.3406 9.83459L14.4705 9.96448C14.7301 10.2241 14.7299 10.6452 14.4705 10.9049C14.2108 11.1646 13.7898 11.1646 13.5301 10.9049L13.4002 10.775L12.1004 12.0739C12.2047 12.3064 12.2654 12.5632 12.2654 12.8346Z"
          fill="currentColor"
        />
        <path
          d="M12.667 1.33496C13.1969 1.33505 13.7054 1.54524 14.0801 1.91992C14.4548 2.29461 14.665 2.80313 14.665 3.33301V7.33496C14.665 7.70225 14.3673 8 14 8C13.6327 8 13.335 7.70225 13.335 7.33496V6.66504H6.66504V13.335H7.33496C7.70225 13.335 8 13.6327 8 14C8 14.3673 7.70225 14.665 7.33496 14.665H3.33301C2.80313 14.665 2.29461 14.4548 1.91992 14.0801C1.54524 13.7054 1.33505 13.1969 1.33496 12.667V3.33301C1.33505 2.80313 1.54524 2.29461 1.91992 1.91992C2.29461 1.54524 2.80313 1.33505 3.33301 1.33496H12.667ZM2.66504 12.667C2.66513 12.8441 2.73509 13.0144 2.86035 13.1396C2.98561 13.2649 3.15587 13.3349 3.33301 13.335H5.33496V6.66504H2.66504V12.667ZM3.33301 2.66504C3.15587 2.66513 2.98561 2.73509 2.86035 2.86035C2.73509 2.98561 2.66513 3.15587 2.66504 3.33301V5.33496H5.33496V2.66504H3.33301ZM6.66504 5.33496H13.335V3.33301C13.3349 3.15587 13.2649 2.98561 13.1396 2.86035C13.0144 2.73509 12.8441 2.66513 12.667 2.66504H6.66504V5.33496Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
